"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconList = exports.IconComponent = void 0;
var react_1 = require("react");
var style = {
    display: "inline-block",
    stroke: "currentColor",
    fill: "currentColor",
};
var IcoMoon = function (_a) {
    var iconSet = _a.iconSet, icon = _a.icon, size = _a.size, title = _a.title, disableFill = _a.disableFill, removeInlineStyle = _a.removeInlineStyle, native = _a.native, SvgComponent = _a.SvgComponent, PathComponent = _a.PathComponent, props = __rest(_a, ["iconSet", "icon", "size", "title", "disableFill", "removeInlineStyle", "native", "SvgComponent", "PathComponent"]);
    if (!iconSet || !icon)
        return null;
    var currentIcon = iconSet.icons.find(function (item) { return item.properties.name === icon; });
    if (!currentIcon)
        return null;
    if (native) {
        style.display = "flex";
        style.flexDirection = "row";
        style.flexWrap = "wrap";
    }
    props.style = __assign(__assign(__assign({}, (removeInlineStyle ? {} : style)), (size ? { width: size, height: size } : {})), (props.style || {}));
    var _b = currentIcon.icon.width, width = _b === void 0 ? "1024" : _b;
    props.viewBox = "0 0 ".concat(width, " 1024");
    var children = currentIcon.icon.paths.map(function (path, index) {
        var pathProps = __assign({ d: path, key: icon + index }, (!disableFill ? currentIcon.icon.attrs[index] : {}));
        return (0, react_1.createElement)(PathComponent || "path", pathProps);
    });
    if (title && !native) {
        children.push((0, react_1.createElement)("title", { key: title }, title));
    }
    return (0, react_1.createElement)(SvgComponent || "svg", props, children);
};
var IconComponent = function () { return null; };
exports.IconComponent = IconComponent;
var iconList = function (iconSet) {
    if (!iconSet || !Array.isArray(iconSet.icons))
        return null;
    return iconSet.icons.map(function (icon) { return icon.properties.name; });
};
exports.iconList = iconList;
exports.default = IcoMoon;
//# sourceMappingURL=index.js.map